module.exports = __webpack_public_path__ + "ratings reviews desktop clean.svg?5f509ea887456d07e06818b2e2ea14c1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/ratings reviews desktop clean.svg
// module id = 116
// module chunks = 0